"use client";

import DOMPurify from "isomorphic-dompurify";
import { breakpointTablet, Heading2Text } from "@gnist/design-system";
import { styled } from "styled-components";
import { Collapse } from "@/components/collapse";
import { tokens } from "@gnist/themes/tokens.css.js";

interface Props {
  description: string | null;
}

const DescriptionWrapper = styled.div`
  max-width: 704px;

  h3 {
    padding-bottom: ${tokens.spacing.s};
    @media screen and (max-width: ${breakpointTablet}) {
      font-size: ${tokens.typeface.size.m};
    }
  }

  b {
    font-weight: ${tokens.typeface.weight.semibold};
  }
`;

export const Description = ({ description }: Props) => {
  if (!description) {
    return null;
  }

  const decoded = description
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("\n", "<br />");

  const sanitized = DOMPurify.sanitize(decoded);

  return (
    <DescriptionWrapper>
      <Heading2Text>Beskrivelse</Heading2Text>
      <Collapse
        id="car-page-description"
        backgroundColorToken={tokens.color.background}
        collapsedHeight="230"
        buttonLabel={{ expand: "Les mer", collapse: "Les mindre" }}
      >
        <div dangerouslySetInnerHTML={{ __html: sanitized }}></div>
      </Collapse>
    </DescriptionWrapper>
  );
};
